// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter_counter__Tx5dj","disabled":"counter_disabled__PJub_","buttonDecrease":"counter_buttonDecrease__gmRPX","buttonIncrease":"counter_buttonIncrease__jAVoS"};